import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { Button, Grid, Modal, Form, Select, Label } from 'semantic-ui-react';
import { useStore } from '../../stores/store';

interface Props {
  closeHandler?: () => void;
  handleFormSubmit: (email: string, body: string, value: string) => void;
  subTaskName: string;
}

function AlertsResolveorRejectModal({
  closeHandler,
  handleFormSubmit,
  subTaskName,
}: Props) {
  const [, setOpen] = React.useState(false);
  const {
    mediaAssetStore,
    activityStore,
    userStore: { getUsers, user },
  } = useStore();
  const { selectedActivity: activity } = activityStore;
  const [value, setValue] = useState('');
  const [roleOptions, setRoleOptions] = useState<
    { key: string; text: string; value: string }[]
  >([]);
  const [emailIds, setEmailIds] = useState('');
  const [selectedRole, setSelectedRole] = useState('');

  useEffect(() => {
    if (getUsers.length > 0) {
      let tempRoles: { key: string; text: string; value: string }[] = [];
      let roleNames: string[] = [];
      roleNames = getUsers?.map((usr) => {
        return usr.roleName;
      });
      roleNames = roleNames.filter(
        (item, index) => roleNames.indexOf(item) === index,
      );
      tempRoles = roleNames?.map((rn) => {
        return {
          key: rn,
          text: rn,
          value: rn,
        };
      });
      setRoleOptions(tempRoles);
    } else {
      setRoleOptions([]);
    }
  }, [getUsers]);

  const setAlertsResolveorRejectModalOpen = () => {
    closeHandler?.();
    mediaAssetStore.setRejectComments(value);
    mediaAssetStore.mediaAsset.redirectOpenReject = false;
    mediaAssetStore.mediaAsset.alertsResolveorRejectModalOpen = false;
  };

  //closes the Alerts modal and opens resolve modal
  const openMediaAssetResolve = () => {
    mediaAssetStore.mediaAsset.redirectOpenReject = false; //setting the redirect reject comment false
    mediaAssetStore.mediaAsset.alertsResolveorRejectModalOpen = false; // setting the AlertsModal false
    mediaAssetStore.openMediaAssetResolveModal(true); // opens resolve modal
  };

  const handleRoleSelection = (e: any, data: any) => {
    setSelectedRole(data.value);
    if (data.value !== '') {
      const collectEmail: string[] = [];
      getUsers?.forEach((selectedUser) => {
        if (selectedUser.roleName === data.value) {
          collectEmail.push(selectedUser.email);
        }
      });
      if (collectEmail.length > 1) {
        setEmailIds(collectEmail.join(','));
      } else {
        setEmailIds(collectEmail[0]);
      }
    } else {
      setEmailIds('');
    }
  };

  const handleSave = () => {
    const bodyContent = `Dear ${selectedRole}, <br/><br/> This is to notify you that ${activity?.title}, ${subTaskName} has been rejected due to ${value}. Please do the needful.<br/><br/>Thanks,<br/>${user?.displayName}`;
    handleFormSubmit(emailIds, bodyContent, value);
  };

  return (
    <Modal
      onClose={() => {
        closeHandler?.();
        setOpen(false);
      }}
      onOpen={() => setOpen(true)}
      open={true}
    >
      <Modal.Header>Reject</Modal.Header>
      {mediaAssetStore.mediaAsset.redirectOpenReject === true ? (
        <>
          <Modal.Content>
            <Modal.Description>
              <Grid.Column style={{ width: '100%' }}>
                {/* <Form>
                  <Form.TextArea
                    label="Rejection Comment"
                    placeholder=" Rejection Comment"
                    value="Ultrasonic has been rejected by Bob"
                  />
                  <Button primary style={{ marginRight: "10px" }}>
                    <Icon name="camera retro" size="large" />
                    Add Photographs
                  </Button>
                </Form> */}
              </Grid.Column>
            </Modal.Description>
          </Modal.Content>
          <Modal.Actions>
            <Button primary content="Resolve" onClick={openMediaAssetResolve} />
            <Button
              color="black"
              content="Cancel"
              onClick={setAlertsResolveorRejectModalOpen}
            />

            <Button
              content="Save"
              labelPosition="right"
              icon="checkmark"
              onClick={setAlertsResolveorRejectModalOpen}
              positive
            />
          </Modal.Actions>
        </>
      ) : (
        <>
          <Modal.Content>
            <Modal.Description>
              <Grid.Column style={{ width: '100%' }}>
                <Form style={{ marginTop: '0px' }}>
                  <div style={{ marginBottom: '20px' }}>
                    <Label>Select Roles</Label>
                    <Select
                      placeholder="Roles"
                      options={roleOptions}
                      className="reject-roles"
                      clearable
                      search
                      onChange={handleRoleSelection}
                    />
                  </div>
                  <Form.TextArea
                    label="Rejection Comment"
                    placeholder="Rejection Comment"
                    value={value}
                    onChange={(e) => setValue(e.currentTarget.value)}
                  />
                </Form>
              </Grid.Column>
            </Modal.Description>
          </Modal.Content>
          <Modal.Actions>
            <Button color="black" onClick={setAlertsResolveorRejectModalOpen}>
              Cancel
            </Button>
            <Button
              content="Save"
              disabled={!value?.length || emailIds.length === 0}
              labelPosition="right"
              icon="checkmark"
              onClick={handleSave}
              positive
            />
          </Modal.Actions>
        </>
      )}
    </Modal>
  );
}

export default observer(AlertsResolveorRejectModal);
